import ProductTHead1 from "components/productCards/ProductTHead1";
import OddsButton1 from "components/productCards/OddsButton1";
import { formatUnixToLabel } from "script";
import { useState } from "react";

const Product1 = ({
  title,
  icon,
  starred,
  info1,
  info2,
  date,
  disabled,
  odds,
  promotedStrikes = [],
}) => {
  const [showAll, setShowAll] = useState(false);
  const starSrc = starred
    ? "/assets/images/icon/star.png"
    : "/assets/images/icon/star2.png";
  return (
    <div
      className={
        "top_matches__cmncard p2-bg p-4 rounded-3 mb-4" +
        (disabled ? " disabled-element" : "")
      }
    >
      <div className="row gx-0 gy-xl-0 gy-7 top_matches__card-row">
        <div className="col-xl-5 col-xxl-4">
          <div className="top_matches__clubname">
            <div className="top_matches__cmncard-right d-flex align-items-start justify-content-between pb-4 mb-4 gap-4">
              <div className="d-flex align-items-center gap-1">
                <img src={icon} width={16} alt="Icon" />{" "}
                <span className="fs-seven top_matches__market-title cpoint">
                  {title}
                </span>
              </div>
              <div className="d-flex align-items-center gap-4 pe-xl-15 flex-nowrap flex-xl-wrap">
                <span className="fs-seven top_matches__market-date cpoint me-xl-6">
                  {formatUnixToLabel(date)}
                </span>
              </div>
            </div>
            <div className="top_matches__cmncard-left d-flex align-items-center justify-content-between pe-xl-10">
              <div>
                <div className="d-flex align-items-center gap-2 mb-4">
                  {/* <img src="/assets/images/icon/cf-ttigres-uanl.png"
                                        alt="Icon" /> */}
                  <span className="fs-seven cpoint">Volume Traded:</span>
                </div>
                <div className="d-flex align-items-center gap-2">
                  {/* <img src="/assets/images/icon/club-america.png"
                                        alt="Icon" /> */}
                  <span className="fs-seven cpoint">Max. Available:</span>
                </div>
              </div>
              <div className="d-flex align-items-center gap-4 position-relative pe-xl-15">
                <div className="d-flex flex-column gap-1">
                  <span className="top_matches__cmncard-countcercle rounded-17 fs-seven">
                    {info1}
                  </span>
                  <span className="top_matches__cmncard-countcercle rounded-17 fs-seven">
                    {info2}
                  </span>
                </div>
                <span className="v-line lg d-none d-xl-block"></span>

                <div className="d-flex flex-column gap-5">
                  <img
                    className="cpoint"
                    src="/assets/images/icon/line-chart.png"
                    alt="Icon"
                  />
                  <img className="cpoint" src={starSrc} alt="Icon" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-7 col-xxl-8 d-xl-flex">
          <div className="top_matches__clubdata top_matches__clubdatatwo">
            <div className="table-responsive">
              <table className="table mb-0 pb-0">
                <ProductTHead1
                  title1="Low Risk/Reward"
                  title2="Moderate Risk/Reward"
                  title3="High Risk/Reward"
                />
                <tbody>
                  <tr>
                    <td className="pt-4" data-label="Low Risk/Reward">
                      <div className="top_matches__innercount d-flex align-items-center gap-2 ">
                        <OddsButton1 {...odds.L1} />
                        <OddsButton1 {...odds.S1} />
                      </div>
                    </td>
                    <td className="pt-4" data-label="Moderate Risk/Reward">
                      <div className="top_matches__innercount d-flex align-items-center gap-2 ">
                        <OddsButton1 {...odds.L2} />
                        <OddsButton1 {...odds.S2} />
                      </div>
                    </td>
                    <td className="pt-4" data-label="High Risk/Reward">
                      <div className="top_matches__innercount d-flex align-items-center gap-2 ">
                        <OddsButton1 {...odds.L3} />
                        <OddsButton1 {...odds.S3} />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {promotedStrikes.length > 0 && (
        <div className="promoted-strikes">
          <button
            className="promoted-strikes-toggle"
            type="button"
            aria-expanded={showAll}
            onClick={() => setShowAll((current) => !current)}
          >
            <span>{showAll ? "Show Less" : "Show All"}</span>
            <span className="promoted-strikes-count">
              {promotedStrikes.length} strikes
            </span>
            <i
              className={`ti ${showAll ? "ti-chevron-up" : "ti-chevron-down"}`}
              aria-hidden="true"
            ></i>
          </button>

          {showAll && (
            <div className="promoted-strikes-grid">
              {promotedStrikes.map((item) => (
                <div className="promoted-strike" key={item.strike}>
                  <div className="promoted-strike-price">
                    Strike {item.strike.toLocaleString()}
                  </div>
                  <div className="promoted-strike-contracts">
                    <OddsButton1 {...item.over} />
                    <OddsButton1 {...item.under} />
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Product1;
